import { GalleryItem } from "../interfaces/gallery";
import { api } from "./api";

export const getJourneyFiles = async (journeyId: number) => {
  const { data } = await api.get<GalleryItem[]>(`/api/v1/journeys/${journeyId}/files`);
  return data;
};
